import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableCell from '@mui/material/TableCell';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {
    height: '74px',
    border: 'none',
    fontSize: '12px',
    padding: '4px 24px',
    borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
    '& .content-parser-row': {
      marginBottom: '0px',
    },
  },
  rootExtra: {},
  lastRowColumn: {
    borderBottom: 'none',
  },
  firstColumn: {},
  lastColumn: {},
  stickyLeftColumn: {
    position: applyEdgeStyle(),
    left: '0px',
    backgroundColor: '#FFF',
    borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
    boxShadow: '2px 0 3px 0 rgba(0,0,0,0.05)',
    zIndex: 50,
  },
  stickyRightColumn: {
    position: applyEdgeStyle(),
    right: '0px',
    backgroundColor: '#FFF',
    boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
    zIndex: 50,
    textAlign: 'center',
  },
  oddRow: {
    backgroundColor: '#FBFBFD',
  },
  noBottomBorder: {
    borderBottom: 'none',
  },
  noBoxShadow: {
    boxShadow: 'none',
  },
  ...(props.styleOverrides ? { ...props.styleOverrides } : {}),
});

/**Browser check and applying edge specific css */
const applyEdgeStyle = () => {
  const nav = window.navigator || navigator;
  return nav && nav.appVersion && nav.appVersion.indexOf('Edge') !== -1 ? 'static' : 'sticky';
};
class TableBodyCell extends React.Component {
  static propTypes = {
    //Data that will be used for cell
    cellData: PropTypes.object.isRequired,
    // Data used to describe column options for cell
    columnData: PropTypes.object.isRequired,
    // Row index value
    rowIndex: PropTypes.number,
    // Column index value
    colIndex: PropTypes.number,
    // Cell is a part of the last visible row
    lastRow: PropTypes.bool.isRequired,
    // Cell is inside of an odd numbered row
    oddRow: PropTypes.bool.isRequired,
    // Developer styles overrides
    styleOverrides: PropTypes.object.isRequired,
    // Styles to be applied to component
    classes: PropTypes.object,
  };

  getCellDisplay = (column, rowIndex, colIndex) => {
    const { isRenderComponent, origRowIndex, value, updateModelValue, renderComponent, superScript } = column;
    const { rowData } = this.props;

    if (isRenderComponent && typeof renderComponent === 'function') {
      this.props.setUpdateComponent(rowIndex, colIndex, this.updateCellRef);
      return renderComponent(
        value,
        { column, row: rowData, origRowIndex, rowIndex, colIndex },
        updateModelValue.bind(null, rowIndex, colIndex, false, true),
      );
    } else {
      if (superScript) {
        return (
          <div className={`display-flex control-superscript-container`}>
            <div className={`display-flex flex-column center-align-superscript`}>
              <span className={'control-superscript-text'}>{superScript}</span>
              <span>{value}</span>
            </div>
          </div>
        );
      }
      return value;
    }
  };

  updateCellRef = () => {
    this.setState({ updateCell: true });
  };

  render() {
    const { classes, cellData, oddRow, lastRow, onClick, columnData, rowIndex, colIndex, totalColumns, hardDisplay = false,disableRow } = this.props;

    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === totalColumns - 1;

    if (!columnData.visible || (!columnData.displayUI && !hardDisplay)) return null;

    const colClass = classNames({
      [classes.root]: true,
      [classes.rootExtra]: true,
      [classes.firstColumn]: isFirstColumn,
      [classes.lastColumn]: isLastColumn,
      [classes.stickyLeftColumn]: columnData.stickyLeft || false,
      [classes.stickyRightColumn]: columnData.stickyRight || false,
      [classes.oddRow]: oddRow || false,
      [classes.lastRowColumn]: lastRow,
      [classes.noBottomBorder]: cellData.removeBottomBorder === true,
      [classes.noBoxShadow]: cellData.removeBoxShadow === true,
    });

    // row color greyout
    const styledData = (disableRow, rowIndex) => {
      if (disableRow && disableRow[rowIndex] === true) {
        return 'rgba(0, 0, 0, 0.38)';
      }
      return '#000000DE'; // Default color
    };
    
    return (
      <MuiTableCell  style={{ color: styledData(disableRow, rowIndex) }}  className={colClass} onClick={onClick}>
        {this.getCellDisplay(cellData, rowIndex, colIndex)}
      </MuiTableCell>
    );
  }
}

export default styled(TableBodyCell)(styles);
